import React, {useEffect} from "react"
import {Route, Routes, useLocation} from "react-router-dom"

import {
	useIsBankUser,
	useIsItUser,
	useIsOnBehalfUser,
	useIsOrgUser,
	useIsPartnerUser,
	useIsManagedSolutionsBankingUser,
	useIsUnitAdminUser,
	useIsUnitReadonlyUser,
	useIsUnitSalesUser,
	useIsUnitSuperUser,
	useIsUnitUser,
} from "../../services/auth"
import {ApplicationsPage} from "../../pages/Applications/ApplicationsPage"
import ApplicationFormsPage from "../../pages/ApplicationForms/ApplicationForms"
import ApplicationFormPage from "../../pages/ApplicationForms/ApplicationForm"
import UnifiedApplicationPage from "../../pages/UnifiedApplications/UnifiedApplicationPage"
import Orgs from "../../pages/Orgs/Orgs"
import {CustomersPage} from "../../pages/Customers/Customers"
import Users from "../../pages/Users/Users"
import UserDetails from "../../pages/Users/UserDetails"
import DepositProducts from "../../pages/DepositProducts/DepositProducts"
import WalletsTerms from "../../pages/WalletsTerms/WalletsTerms"
import BillPayTerms from "../../pages/BillPayTerms/BillPayTerms"
import NewBillPayTerms from "../../pages/BillPayTerms/NewBillPayTerms"
import BillPayOrgSettingsPage from "../../pages/BillPayOrgSettings/BillPayOrgSettings"
import Webhooks from "../../pages/Webhooks/Webhooks"
import ApiTokensPage from "../../pages/ApiTokens/ApiTokens"
import ChangePassword from "../../pages/ChangePassword/ChangePassword"
import NewDepositProduct from "../../pages/DepositProduct/NewDepositProduct"
import NewWalletTerms from "../../pages/WalletTerms/NewWalletTerms"
import DepositProduct from "../../pages/DepositProduct/DepositProduct"
import WalletTerms from "../../pages/WalletTerms/WalletTerms"
import {BatchAccountsPage} from "../../pages/BatchAccounts/BatchAccounts"
import Org from "../../pages/Orgs/Org"
import NewOrg from "../../pages/Orgs/NewOrg"
import OrgAccountPage from "../../pages/OrgDashboard/OrgAccountPage"
import AccountPage from "../../pages/Account/Account"
import TransactionPage from "../../pages/Transaction/Transaction"
import OrgTransactionPage from "../../pages/OrgDashboard/OrgTransactionPage"
import UnitDashboard from "../../pages/UnitDashboard/UnitDashboard"
import DisputesPage from "../../pages/Disputes/Disputes"
import DisputePage from "../../pages/Disputes/Dispute"
import CardDesigns from "../../pages/CardDesigns/CardDesigns"
import IncomingAchPage from "../../pages/IncomingAch/IncomingAch"
import TransactionMonitoringSettingsList from "../../pages/TransactionMonitoring/TransactionMonitoringSettingsList"
import TransactionMonitoringSettings from "../../pages/TransactionMonitoring/TransactionMonitoringSettings"
import NewTransactionMonitoringSettings from "../../pages/TransactionMonitoring/NewTransactionMonitoringSettings"
import {BinsPage} from "../../pages/Bins/Bins"
import PaymentPage from "../../pages/Payments/Payment"
import OrgPaymentPage from "../../pages/OrgDashboard/OrgPaymentPage"
import Payments from "../../pages/Payments/Payments"
import AuthorizationPage from "../../pages/Authorization/Authorization"
import OrgAuthorizationPage from "../../pages/OrgDashboard/OrgAuthorizationPage"
import Customer from "../../pages/Customer/Customer"
import Adjustments from "../../pages/Adjustments/Adjustments"
import AdjustmentPage from "../../pages/Adjustments/Adjustment"
import OrgSettings from "../../pages/OrgSettings/OrgSettings"
import AdminPage from "../../pages/Admin/Admin"
import {documentTitle} from "../../index"
import OrgBankAgreements from "../../pages/OrgBankAgreement/OrgBankAgreements"
import NewOrgBankAgreement from "../../pages/OrgBankAgreement/NewOrgBankAgreement"
import OrgBankAgreement from "../../pages/OrgBankAgreement/OrgBankAgreement"
import {useCanAccessProductApplications, hasPermission} from "../../services/permission"
import {NewSandboxClient, NewUnitPilotClient} from "../../pages/Orgs/NewClient"
import {AccountsPage} from "../../pages/Accounts/Accounts"
import UnitPilotOverview from "../../pages/UnitPilotOverview/UnitPilotOverview"
import {CheckDepositsPage} from "../../pages/CheckDeposits/CheckDeposits"
import {isLocalEnv, isSandboxEnv} from "../../utilities/environment"
import Sidebar from "../../components/Sidebar/Sidebar"
import Navbar from "../../components/Navbar/Navbar"
import {initializeClickTracking} from "../../utilities/tracking"
import {RedirectWithLocationChange} from "./RedirectWithLocationChange"
import {PrefixPathRedirect} from "./PrefixPathRedirect"
import ReceivedPaymentsPage from "../../pages/ReceivedPayments/ReceivedPayments"
import ReceivedPayment from "../../pages/ReceivedPayments/ReceivedPayment"
import CheckDepositPage, {CheckDepositTabConstants} from "../../pages/CheckDeposits/CheckDeposit"
import ApplicationPage from "../../pages/Applications/ApplicationPage"
import ProductApplicationPage from "../../pages/ProductApplications/ProductApplicationPage"
import {Redirect} from "react-router6-redirect"
import IncomingWiresPage from "../../pages/IncomingWires/IncomingWires"
import IncomingWirePage from "../../pages/IncomingWires/IncomingWire"
import IncomingRtpPage from "../../pages/IncomingRtp/IncomingRtp"
import IncomingRealTimePaymentPage from "../../pages/IncomingRtp/IncomingRealTimePayment"
import {AuthenticatedRoute} from "../AuthenticatedRoute/AuthenticatedRoute"
import CheckPaymentsPage from "../../pages/CheckPayments/CheckPayments"
import CheckPaymentPage from "../../pages/CheckPayments/CheckPayment"
import BillsPage from "../../pages/Bills/Bills"
import BillPage from "../../pages/Bills/Bill"
import EditBillPage from "../../pages/Bills/EditBill"
import VendorPage from "../../pages/Vendors/Vendor"
import InterestSettingsPage from "../../pages/InterestSettings/InterestSettings"
import {LinkedAccountsPage} from "../../pages/LinkedAccounts/LinkedAccounts"
import LinkedAccountPage from "../../pages/LinkedAccounts/LinkedAccount"
import IncomingChecksPage from "../../pages/IncomingChecks/IncomingChecks"
import IncomingCheckPage from "../../pages/IncomingChecks/IncomingCheck"
import IncomingAchsPage from "../../pages/IncomingAchs/IncomingAchsPage"
import BankSettings from "../../pages/BankSettings/BankSettings"
import {
	ReevaluateApplicationPage,
	ReevaluateBeneficialOwnerPage,
	ReevaluateOfficerPage,
} from "../../pages/ReevaluateApplication/ReevaluatePage"
import {
	ReevaluateProductApplicationPage,
	ReevaluateProductApplicationOfficerPage,
	ReevaluateProductApplicationBeneficialOwnerPage,
} from "../../pages/ReevaluateProductApplication/ReevaluateProductApplicationPage"
import {PartneOnBehalfRedirect} from "../../pages/PartneOnBehalfRedirect"
import Banks from "../../pages/Banks/Banks"
import Bank from "../../pages/Banks/Bank"
import ManagedSolutionsEditorPage from "../../pages/ManagedSolutionsEditor/ManagedSolutionsEditor"
import classNames from "classnames"
import {useOrgBankingSetup} from "../../services/orgBankingSetup"
import {ManagedSolutionsHomepage} from "../../pages/ManagedSolutionsHomepage/ManagedSolutionsHomepage"
import OrgDashboard from "../../pages/OrgDashboard/OrgDashboard"
import ManagedSolutionsSettings from "../../pages/ManagedSolutionsSettings/ManagedSolutionsSettings"
import ManagedSolutionsAdminOrg from "../../pages/Admin/ManagedSolutionsAdmin/ManagedSolutionsAdminOrg"
import useChatbot from "../../hooks/useChatbot"
import {CardsPage} from "../../pages/Cards/Cards"
import CardPage from "../../pages/Card/Card"
import {ManagedSolutionsCustomersPage} from "../../pages/ManagedSolutionsCustomers/ManagedSolutionsCustomers"
import {ManagedSolutionsAccountsPage} from "../../pages/ManagedSolutionsAccounts/ManagedSolutionsAccounts"
import {ManagedSolutionsApplicationsPage} from "../../pages/ManagedSolutionsApplications/ManagedSolutionsApplications"
import {ManagedSolutionsApplicationFormsPage} from "../../pages/ManagedSolutionsApplicationForms/ManagedSolutionsApplicationForms"
import ManagedSolutionsApplicationPage from "../../pages/ManagedSolutionsApplication/ManagedSolutionsApplication"
import ManagedSolutionsApplicationFormPage from "../../pages/ManagedSolutionsApplicationForm/ManagedSolutionsApplicationForm"
import ManagedSolutionsCustomerPage from "../../pages/ManagedSolutionsCustomer/ManagedSolutionsCustomer"
import ManagedSolutionsAccountPage from "../../pages/ManagedSolutionsAccount/ManagedSolutionsAccount"
import {ManagedSolutionsOrgAccountsPage} from "../../pages/ManagedSolutionsOrgAccounts/ManagedSolutionsOrgAccounts"
import {ManagedSolutionsUsersPage} from "../../pages/ManagedSolutionsUsers/ManagedSolutionsUsers"
import ManagedSolutionsUserPage from "../../pages/ManagedSolutionsUser/ManagedSolutionsUser"
import {ManagedSolutionsIntentsPage} from "../../pages/ManagedSolutionsIntents/ManagedSolutionsIntents"
import ManagedSolutionsIntentPage from "../../pages/ManagedSolutionsIntent/ManagedSolutionsIntent"

export function DefaultLayout() {
	const location = useLocation()
	const isItUser = useIsItUser()
	const canAccessProductApps = useCanAccessProductApplications()
	const isManagedSolutionsBranding = location.pathname === "/managed-solutions/branding"
	const isSidebarShown = !isItUser && !isManagedSolutionsBranding

	useChatbot()

	useEffect(() => {
		document.title = documentTitle

		if (isLocalEnv() || isSandboxEnv()) {
			initializeClickTracking()
		}
	}, [])

	let homeRoute
	const isUsersLimited = useIsItUser()
	const isOrgLimited = useIsOrgUser() || useIsOnBehalfUser()
	const isPartnerLimited = useIsPartnerUser()
	const {setup} = useOrgBankingSetup()
	const isManagedSolutionsBankingUser = useIsManagedSolutionsBankingUser()
	if (isPartnerLimited) {
		homeRoute = <Route path="/" element={<RedirectWithLocationChange path={"/orgs"} />} />
	} else if (isUsersLimited) {
		homeRoute = <Route path="/" element={<RedirectWithLocationChange path={"/users"} />} />
	} else if (isOrgLimited) {
		homeRoute = (
			<Route
				path="/"
				element={
					setup === "ReadyToLaunchBanking" || isManagedSolutionsBankingUser ? (
						<ManagedSolutionsHomepage />
					) : (
						<OrgDashboard />
					)
				}
			/>
		)
	} else {
		homeRoute = <Route path="/*" element={<UnitDashboard />} />
	}

	const isUnitUser = useIsUnitUser()
	const isBankUser = useIsBankUser()
	const isUnitOrBankUser = isUnitUser || isBankUser
	const canViewIncomingRtp = isUnitUser

	return (
		<>
			<Navbar />
			{isSidebarShown ? <Sidebar /> : null}

			<div className={classNames("layout-content-inner", !isSidebarShown && "full-width")}>
				<Routes>
					<Route path="/applications" element={<ApplicationsPage />} />
					{useIsUnitUser() && <Route path="/application-forms" element={<ApplicationFormsPage />} />}
					{useIsUnitUser() && <Route path="/application-forms/:id" element={<ApplicationFormPage />} />}
					{useIsUnitUser() && (
						<Route path="/unified-applications/:unifiedApplicationId" element={<UnifiedApplicationPage />} />
					)}
					<Route path="/customers" element={<CustomersPage />} />
					<Route path="/orgs" element={<Orgs />} />
					{isUnitUser && <Route path="/banks" element={<Banks />} />}
					<Route path="/orgs/new" element={<NewOrg />} />
					{useIsUnitUser() ? <Route path="/sandbox-client/new" element={<NewSandboxClient />} /> : null}
					{useIsUnitSuperUser() || useIsUnitSalesUser() ? (
						<Route path="/unit-pilot-client/new" element={<NewUnitPilotClient />} />
					) : null}
					<Route path="/orgs/:orgId" element={<Org />} />
					{isUnitUser && <Route path="/banks/:bankId" element={<Bank />} />}
					{hasPermission("user", "get") ? <Route path="/users" element={<Users />} /> : null}
					<Route path="/user-details/:userId/*" element={<UserDetails />} />
					<Route path="/webhooks" element={<Webhooks />} />
					<Route path="/org-settings" element={<OrgSettings />} />
					<Route path="/managed-solutions/settings" element={<ManagedSolutionsSettings />} />
					{useIsUnitAdminUser() || useIsUnitReadonlyUser() ? <Route path="/admin" element={<AdminPage />} /> : null}
					{useIsUnitAdminUser() || useIsUnitReadonlyUser() ? (
						<Route path="/admin/email-templates/:templateId" element={<AdminPage />} />
					) : null}
					{useIsUnitAdminUser() || useIsUnitReadonlyUser() ? (
						<Route path="/admin/managed-solutions/:orgId" element={<ManagedSolutionsAdminOrg />} />
					) : null}
					<Route path="/bank-settings" element={<BankSettings />} />
					<Route path="/pilot-overview" element={<UnitPilotOverview />} />
					<Route path="/card-designs" element={<CardDesigns />} />
					<Route path="/deposit-products" element={<DepositProducts />} />
					<Route path="/deposit-products/new" element={<NewDepositProduct />} />
					<Route path="/deposit-products/:depositProductId" element={<DepositProduct />} />
					<Route path="/wallet-terms" element={<WalletsTerms />} />
					<Route path="/wallet-terms/new" element={<NewWalletTerms />} />
					<Route path="/wallet-terms/:walletTermsId" element={<WalletTerms />} />
					{isUnitUser && <Route path="/billpay-terms/new" element={<NewBillPayTerms />} />}
					{isUnitUser && <Route path="/billpay-terms/:billpayTermsId" element={<BillPayTerms />} />}
					{isUnitUser && <Route path="/billpay-org-settings/:settingsId" element={<BillPayOrgSettingsPage />} />}
					<Route path="/disputes" element={<DisputesPage />} />
					<Route path="/disputes/:disputeId" element={<DisputePage />} />
					<Route path="/api-tokens" element={<ApiTokensPage />} />
					<Route path="/change-password" element={<ChangePassword />} />
					<Route path="/change-password/:userId" element={<ChangePassword />} />
					<Route path="/applications/individual/:applicationId" element={<ApplicationPage />} />
					<Route path="/applications/business/:applicationId" element={<ApplicationPage />} />
					<Route path="/applications/:applicationId" element={<ApplicationPage />} />
					<Route path="/applications/:applicationId/resubmit" element={<ReevaluateApplicationPage />} />
					<Route
						path="/applications/:applicationId/beneficialOwner/:beneficialOwnerId/resubmit"
						element={<ReevaluateBeneficialOwnerPage />}
					/>
					<Route path="/applications/:applicationId/officer/resubmit" element={<ReevaluateOfficerPage />} />
					{canAccessProductApps && (
						<>
							<Route
								path="/product-applications/:productApplicationId/resubmit"
								element={<ReevaluateProductApplicationPage />}
							/>
							<Route
								path="/product-applications/:productApplicationId/officer/resubmit"
								element={<ReevaluateProductApplicationOfficerPage />}
							/>
							<Route
								path="/product-applications/:productApplicationId/beneficialOwner/:beneficialOwnerId/resubmit"
								element={<ReevaluateProductApplicationBeneficialOwnerPage />}
							/>
							<Route path="/product-applications/:productApplicationId" element={<ProductApplicationPage />} />
						</>
					)}
					<Route path="/customers/individual/:customerId/*" element={<Customer />} />
					<Route path="/customers/business/:customerId/*" element={<Customer />} />
					<Route path="/customers/businessFBO/:customerId/*" element={<Customer />} />
					<Route path="/customers/individualWallet/:customerId/*" element={<Customer />} />
					<Route path="/customers/businessWallet/:customerId/*" element={<Customer />} />
					<Route path="/customers/:customerId/*" element={<Customer />} />
					<Route path="/onboarding/*" element={<Redirect to="/applications" />} />
					<Route path="/accounts/:accountId/*" element={<AccountPage />} />
					<Route path="/batch-accounts/*" element={<BatchAccountsPage />} />
					<Route path="/transaction/:accountId/:transactionId/*" element={<TransactionPage />} />
					<Route path="/org-transaction/:accountId/:transactionId/*" element={<OrgTransactionPage />} />
					<Route key="payments" path="/payments" element={<Payments />} />
					<Route key="checkPayments" path="/check-payments" element={<CheckPaymentsPage />} />
					<Route path="/check-payments/:checkPaymentId/*" element={<CheckPaymentPage />} />
					<Route key="bills" path="/bills" element={<BillsPage />} />
					<Route path="/bills/:billId/edit" element={<EditBillPage />} />
					<Route path="/bills/:billId/*" element={<BillPage />} />
					<Route path="/vendors/:vendorId/*" element={<VendorPage />} />
					<Route key="receivedPayments" path="/received-payments" element={<ReceivedPaymentsPage />} />
					<Route
						path="/received-payments/:receivedPaymentId/assignments/*"
						element={<ReceivedPayment assignmentsView />}
					/>
					<Route path="/received-payments/:receivedPaymentId/*" element={<ReceivedPayment />} />
					<Route key="accounts" path="/accounts" element={<AccountsPage />} />
					{hasPermission("card", "get") && <Route key="cards" path="/cards" element={<CardsPage />} />}
					<Route path="/cards/:cardId/*" element={<CardPage />} />
					<Route path="/payments/:paymentId/assignments/*" element={<PaymentPage assignmentsView={true} />} />
					<Route path="/payments/:paymentId/*" element={<PaymentPage />} />
					<Route path="/authorization/:authorizationId/*" element={<AuthorizationPage />} />
					<Route path="/org-payment/:paymentId/*" element={<OrgPaymentPage />} />
					{hasPermission("checkDeposit", "get") && (
						<Route key="incoming-checks" path="/check-deposits" element={<CheckDepositsPage />} />
					)}
					<Route
						path="/check-deposits/:checkId/*"
						element={<CheckDepositPage tab={CheckDepositTabConstants.FullCheckDepositDetails} />}
					/>
					<Route
						path="/check-deposits/:checkId/assignments/*"
						element={<CheckDepositPage tab={CheckDepositTabConstants.ActionsRequired} />}
					/>
					<Route path="/org-account/:accountId/*" element={<OrgAccountPage />} />
					<Route path="/org-authorization/:authorizationId/*" element={<OrgAuthorizationPage />} />
					{hasPermission("incomingWire", "get") && (
						<Route key="incoming-wires" path="/incoming-wires" element={<IncomingWiresPage />} />
					)}
					{hasPermission("incomingWire", "get") && (
						<Route key="incoming-wires" path="/incoming-wires/:incomingWireId" element={<IncomingWirePage />} />
					)}
					{canViewIncomingRtp && <Route key="incoming-rtp" path="/incoming-rtp" element={<IncomingRtpPage />} />}
					{canViewIncomingRtp && (
						<Route
							key="incoming-rtp-details"
							path="/incoming-real-time-payments/:incomingRealTimePaymentId"
							element={<IncomingRealTimePaymentPage />}
						/>
					)}
					{hasPermission("incomingAch", "get") && (
						<Route key="incoming-achs" path="/incoming-achs" element={<IncomingAchsPage />} />
					)}
					{hasPermission("incomingAch", "get") && (
						<Route key="incoming-achs" path="/incoming-achs/:incomingAchId/*" element={<IncomingAchPage />} />
					)}
					{hasPermission("incomingCheck", "get") && (
						<Route key="incoming-checks" path="/incoming-checks" element={<IncomingChecksPage />} />
					)}
					{hasPermission("incomingCheck", "get") && (
						<Route key="incoming-checks" path="/incoming-checks/:incomingCheckId" element={<IncomingCheckPage />} />
					)}
					{isUnitOrBankUser
						? [
								<Route key="org-bank-agreements" path="/org-bank-agreements" element={<OrgBankAgreements />} />,
								<Route
									key={"/org-bank-agreements/:name"}
									path="/org-bank-agreements/:id"
									element={<OrgBankAgreement />}
								/>,
						  ]
						: null}
					{useIsUnitUser()
						? [
								<Route key="/adjustments" path="/adjustments" element={<Adjustments />} />,
								<Route
									key="/adjustments/:adjustmentId"
									path="/adjustments/:adjustmentId"
									element={<AdjustmentPage />}
								/>,
								<Route
									key="transaction-monitoring"
									path="/transaction-monitoring"
									element={<TransactionMonitoringSettingsList />}
								/>,
								<Route
									key="transaction-monitoring/new"
									path="/transaction-monitoring/new"
									element={<NewTransactionMonitoringSettings />}
								/>,
								<Route
									key="transaction-monitoring/:settingsId"
									path="/transaction-monitoring/:settingsId"
									element={<TransactionMonitoringSettings />}
								/>,
								<Route key="bins" path="/bins/*" element={<BinsPage />} />,
								<Route
									key="/org-bank-agreements/new"
									path="/org-bank-agreements/new"
									element={<NewOrgBankAgreement />}
								/>,
								<Route path="/linked-accounts/*" key={"/linked-accounts"} element={<LinkedAccountsPage />} />,
								<Route
									path="/linked-accounts/:linkedAccountId/*"
									key={"/linked-accounts/:linkedAccountId"}
									element={<LinkedAccountPage />}
								/>,
						  ]
						: null}
					{/* Legacy routes redirects (old routes that shouldn't be used anymore, but we redirect them in case they were) */}
					<Route path="/org/new" element={<Redirect to="/orgs/new" />} />
					<Route path="/deposit-product/new" element={<Redirect to="/deposit-products/new" />} />
					<Route
						path="/deposit-product/:depositProductId"
						element={<Redirect to="/deposit-products/:depositProductId" />}
					/>
					<Route path="/dispute/:disputeId" element={<Redirect to="/disputes/:disputeId" />} />
					<Route
						path="/application/individual/:applicationId"
						element={<Redirect to="/applications/individual/:applicationId" />}
					/>
					<Route
						path="/application/business/:applicationId"
						element={<Redirect to="/applications/business/:applicationId" />}
					/>
					<Route path="/individual/:customerId" element={<Redirect to="/customers/individual/:customerId" />} />
					<Route path="/business/:customerId" element={<Redirect to="/customers/business/:customerId" />} />
					<Route path="/businessFBO/:customerId" element={<Redirect to="/customers/businessFBO/:customerId" />} />
					<Route
						path="/individualWallet/:customerId"
						element={<Redirect to="/customers/individualWallet/:customerId" />}
					/>
					<Route path="/businessWallet/:customerId" element={<Redirect to="/customers/businessWallet/:customerId" />} />
					<Route path="/customer/:customerId" element={<Redirect to="/customers/:customerId" />} />
					<Route path="/account/:accountId" element={<Redirect to="/accounts/:accountId" />} />
					<Route path="/payment/:paymentId" element={<Redirect to="/payments/:paymentId" />} />
					<Route path="/adjustment/:adjustmentId" element={<Redirect to="/adjustments/:adjustmentId" />} />,
					<Route path="/incoming-ach/:incomingAchId" element={<Redirect to="/incoming-achs/:incomingAchId" />} />,
					<Route
						path="/incoming-check/:incomingCheckId"
						element={<Redirect to="/incoming-checks/:incomingCheckId" />}
					/>
					,
					<Route key="/interest-settings" path="/interest-settings" element={<InterestSettingsPage />} />,
					<Route path="/transactions-monitoring" element={<Redirect to="/transaction-monitoring" />} />,
					<Route path="/org-bank-agreement/new" element={<Redirect to="/org-bank-agreements/new" />} />,
					<Route path="/org-bank-agreement/:id" element={<Redirect to="/org-bank-agreements/:id" />} />
					<Route path="/partner-on-behalf/:orgId" element={<PartneOnBehalfRedirect />} />
					<Route path="/managed-solutions/branding" element={<ManagedSolutionsEditorPage />} />
					<Route path="/managed-solutions/application-forms" element={<ManagedSolutionsApplicationFormsPage />} />
					<Route
						path="/managed-solutions/application-forms/:applicationFormId"
						element={<ManagedSolutionsApplicationFormPage />}
					/>
					<Route path="/managed-solutions/applications" element={<ManagedSolutionsApplicationsPage />} />
					<Route path="/managed-solutions/applications/:applicationId" element={<ManagedSolutionsApplicationPage />} />
					<Route path="/managed-solutions/customers" element={<ManagedSolutionsCustomersPage />} />
					<Route path="/managed-solutions/customers/:customerId" element={<ManagedSolutionsCustomerPage />} />
					<Route path="/managed-solutions/accounts" element={<ManagedSolutionsAccountsPage />} />
					<Route path="/managed-solutions/accounts/:accountId" element={<ManagedSolutionsAccountPage />} />
					<Route path="/managed-solutions/org-accounts" element={<ManagedSolutionsOrgAccountsPage />} />
					<Route path="/managed-solutions/users" element={<ManagedSolutionsUsersPage />} />
					<Route path="/managed-solutions/users/:userId" element={<ManagedSolutionsUserPage />} />
					{/* Redirects from legacy Ready-to-Launch paths */}
					<Route
						path="/ready-to-launch/*"
						element={<PrefixPathRedirect fromPrefix="/ready-to-launch" toPrefix="/managed-solutions" />}
					/>
					<Route
						path="/admin/ready-to-launch/*"
						element={<PrefixPathRedirect fromPrefix="/admin/ready-to-launch" toPrefix="/admin/managed-solutions" />}
					/>
					<Route path="/managed-solutions/intents" element={<ManagedSolutionsIntentsPage />} />
					<Route path="/managed-solutions/intents/:intentId" element={<ManagedSolutionsIntentPage />} />
					{homeRoute}
				</Routes>
			</div>
		</>
	)
}

export function AuthenticatedDefaultLayout() {
	return (
		<AuthenticatedRoute>
			<DefaultLayout />
		</AuthenticatedRoute>
	)
}
